import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class ClientAuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // const user = this.authService.userValue;

    // if (user) {
    //   // check if route is restricted by role
    //   if (
    //     route.data['roles'] &&
    //     route.data['roles'].indexOf(user?.data?.role_id) === -1
    //   ) {
    //     // role not authorised so redirect to home page
    //     this.router.navigate(['/login']);
    //     return false;
    //   }

    //   // authorised so return true
    //   return true;
    // }

    // // not logged in so redirect to login page with the return url
    // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    // return false;
    return true;
  }
}
